/* Section Rendering enhancement. Forms and pagination remain usable without JS. */
(() => {
  'use strict';
  if (window.__sc3Listing) return;
  window.__sc3Listing = true;
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => Array.from(root.querySelectorAll(s));
  let root, controller, sequence = 0, urls = [], retry, scrollFrame = 0, observer, resize;
  let sheetTrigger, sheetLocked = false;
  const cleanURL = value => {
    const url = new URL(value, location.href);
    url.searchParams.delete('section_id');
    url.searchParams.delete('view');
    if (root?.dataset.sc3SearchPage === 'true') url.searchParams.set('type', 'product');
    return url;
  };
  const status = text => { const node = root && $('[data-sc3-listing-status]', root); if (node) node.textContent = text; };
  function save() {
    if (!root || !urls.length) return;
    history.replaceState({ ...history.state, sc3Listing: { urls: urls.slice(), y: window.scrollY } }, '', location.href);
  }
  function closeSheet(restore = true) {
    const dialog = root && $('[data-sc3-filter-dialog]', root);
    if (!dialog?.open) return;
    dialog.close();
    $('[data-sc3-filter-home]', root).append($('[data-sc3-filter-form]', dialog));
    $('[data-sc3-filter-close]', root).hidden = true;
    document.documentElement.classList.toggle('sc3-lock', sheetLocked);
    sheetTrigger?.setAttribute('aria-expanded', 'false');
    if (restore && sheetTrigger?.isConnected) sheetTrigger.focus({ preventScroll: true });
  }
  function openSheet() {
    const dialog = $('[data-sc3-filter-dialog]', root);
    if (!dialog?.showModal) return;
    sheetTrigger = $('[data-sc3-filter-open]', root);
    sheetLocked = document.documentElement.classList.contains('sc3-lock');
    dialog.append($('[data-sc3-filter-form]', root));
    $('[data-sc3-filter-close]', dialog).hidden = false;
    dialog.showModal();
    document.documentElement.classList.add('sc3-lock');
    sheetTrigger.setAttribute('aria-expanded', 'true');
    $('[data-sc3-filter-close]', dialog).focus();
  }
  function offset() {
    if (!root) return;
    const header = $('.sc3-header-section');
    const top = header && !header.classList.contains('sc3-scroll-hidden') ? header.offsetHeight : 0;
    root.style.setProperty('--sc3-listing-top', top + 'px');
  }
  function init(node) {
    root = node;
    root.classList.add('sc3-listing-ready');
    const button = $('[data-sc3-filter-open]', root);
    if (button && $('[data-sc3-filter-dialog]', root)?.showModal) button.hidden = false;
    // Browsers without native dialog retain the inline mobile filter form.
    if (button?.hidden) root.classList.remove('sc3-listing-ready');
    const more = $('[data-sc3-description-toggle]', root);
    if (more) more.hidden = false;
    $$('[data-sc3-listing-link],[data-sc3-load-more]', root).forEach(a => { a.href = cleanURL(a.href).href; });
    $('[data-sc3-filter-dialog]', root).addEventListener('cancel', event => { event.preventDefault(); closeSheet(); });
    const header = $('.sc3-header-section');
    observer?.disconnect(); resize?.disconnect();
    if (header) {
      observer = new MutationObserver(offset); observer.observe(header, { attributes: true, attributeFilter: ['class'] });
      if (window.ResizeObserver) { resize = new ResizeObserver(offset); resize.observe(header); }
    }
    offset();
  }
  async function fetchSection(url, signal) {
    const request = cleanURL(url);
    if (request.origin !== location.origin) throw new Error('Origin');
    request.searchParams.set('section_id', root.dataset.sc3Listing);
    const response = await fetch(request.href, { signal, headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('Section');
    const document = new DOMParser().parseFromString(await response.text(), 'text/html');
    const next = $('[data-sc3-listing]', document);
    if (!next || next.dataset.sc3Listing !== root.dataset.sc3Listing || !$('[data-sc3-grid]', next)) throw new Error('Markup');
    return next;
  }
  async function navigate(value, options = {}) {
    const target = cleanURL(value);
    clearTimeout(scrollFrame);
    const ticket = ++sequence;
    controller?.abort(); controller = new AbortController();
    const signal = controller.signal;
    const wasSheet = !!$('[data-sc3-filter-dialog]', root)?.open;
    const active = document.activeElement;
    const focusId = root.contains(active) ? active.id : '';
    const oldCount = $$('[data-sc3-grid] > [data-sc3-card]', root).length;
    root.setAttribute('aria-busy', 'true');
    $('.sc3-listing-error', root).hidden = true;
    status(root.dataset.sc3Loading);
    retry = () => navigate(target.href, options);
    try {
      const restoreURLs = options.restore?.urls || [target.href];
      const pages = [];
      for (const url of restoreURLs) {
        pages.push(await fetchSection(url, signal));
        if (ticket !== sequence) return;
      }
      const next = pages[0];
      if (pages.length > 1) {
        const grid = $('[data-sc3-grid]', next);
        for (const page of pages.slice(1)) {
          $$('img', page).forEach(img => { img.loading = 'lazy'; img.fetchPriority = 'auto'; });
          grid.append(...$$('[data-sc3-grid] > [data-sc3-card]', page));
        }
        $('[data-sc3-pagination]', next).replaceWith($('[data-sc3-pagination]', pages[pages.length - 1]));
      }
      if (ticket !== sequence) return;
      if (!options.pop) save();
      if (options.append) {
        const grid = $('[data-sc3-grid]', root);
        const ids = new Set($$('[data-sc3-card]', grid).map(card => card.dataset.sc3Card));
        $$('[data-sc3-grid] > [data-sc3-card]', next).forEach(card => {
          if (!ids.has(card.dataset.sc3Card)) { $$('img', card).forEach(img => { img.loading = 'lazy'; img.fetchPriority = 'auto'; }); grid.append(card); }
        });
        $('[data-sc3-pagination]', root).replaceWith($('[data-sc3-pagination]', next));
        urls.push(target.href);
        $$('[data-sc3-listing-link],[data-sc3-load-more]', root).forEach(a => { a.href = cleanURL(a.href).href; });
      } else {
        closeSheet(false);
        root.replaceWith(next);
        init(next);
        urls = restoreURLs.map(url => cleanURL(url).href);
      }
      $('[data-sc3-listing-empty]', root).hidden = !!$('[data-sc3-grid] > [data-sc3-card]', root);
      const state = { ...history.state, sc3Listing: { urls: urls.slice(), y: options.restore?.y ?? window.scrollY } };
      if (!options.pop) history[options.append || options.replace ? 'replaceState' : 'pushState'](state, '', target.href);
      if (options.restore) window.scrollTo({ top: options.restore.y || 0, behavior: 'instant' });
      else if (wasSheet && !options.close) {
        openSheet();
        if (focusId) document.getElementById(focusId)?.focus({ preventScroll: true });
      } else if (options.append) {
        const card = $$('[data-sc3-grid] > [data-sc3-card]', root)[oldCount];
        (card?.querySelector('a') || $('[data-sc3-load-more]', root) || $('h1', root))?.focus({ preventScroll: true });
      } else {
        const control = focusId && document.getElementById(focusId);
        (control || $('h1', root))?.focus({ preventScroll: true });
      }
      status($('[data-sc3-result-count]', root).textContent.trim());
      retry = null;
    } catch (error) {
      if (ticket !== sequence || error.name === 'AbortError') return;
      $('.sc3-listing-error', root).hidden = false;
      status($('.sc3-listing-error p', root).textContent);
      if (options.pop) {
        // Keep the URL and visible controls consistent on a failed Back restoration.
        $('.sc3-listing-error', root).scrollIntoView({ block: 'nearest' });
      }
    } finally {
      if (ticket === sequence) {
        root.removeAttribute('aria-busy');
        $$('[data-sc3-load-more]', root).forEach(a => a.removeAttribute('aria-disabled'));
      }
    }
  }
  function formURL(form) {
    const url = cleanURL(form.action);
    // Preserve preview-theme and other non-filter context, but drop obsolete query/filter state.
    const current = new URL(location.href);
    current.searchParams.forEach((value, key) => {
      if (!key.startsWith('filter.') && !['page', 'q', 'type', 'sort_by', 'section_id', 'view', 'options[prefix]'].includes(key)) url.searchParams.set(key, value);
    });
    const data = new FormData(form);
    new Set(data.keys()).forEach(key => url.searchParams.delete(key));
    data.forEach((value, key) => { if (String(value).trim()) url.searchParams.append(key, value); });
    if (root.dataset.sc3SearchPage === 'true') url.searchParams.set('type', 'product');
    url.searchParams.delete('page');
    return url;
  }
  document.addEventListener('click', event => {
    if (!root || !root.contains(event.target)) return;
    const el = event.target.closest('button,a');
    if (!el) return;
    if (el.matches('[data-sc3-filter-open]')) openSheet();
    else if (el.matches('[data-sc3-filter-close]')) closeSheet();
    else if (el.matches('[data-sc3-listing-retry]')) retry?.();
    else if (el.matches('[data-sc3-description-toggle]')) {
      const expanded = el.getAttribute('aria-expanded') !== 'true';
      el.setAttribute('aria-expanded', String(expanded));
      $('[data-sc3-description]', root).classList.toggle('sc3-description-open', expanded);
      el.textContent = expanded ? el.dataset.sc3Less : el.dataset.sc3More;
    } else if (el.matches('[data-sc3-listing-link],[data-sc3-load-more]')) {
      if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const append = el.matches('[data-sc3-load-more]');
      if (append && root.hasAttribute('aria-busy')) return;
      if (append) el.setAttribute('aria-disabled', 'true');
      navigate(el.href, { append });
    }
  });
  document.addEventListener('submit', event => {
    if (!root?.contains(event.target) || !event.target.matches('[data-sc3-filter-form],[data-sc3-listing-search]')) return;
    event.preventDefault();
    const url = formURL(event.target);
    if (url.href === cleanURL(location.href).href && !root.hasAttribute('aria-busy')) closeSheet();
    else navigate(url.href, { close: true });
  });
  document.addEventListener('change', event => {
    if (!root?.contains(event.target)) return;
    const form = $('[data-sc3-filter-form]', root);
    if (event.target.matches('[data-sc3-sort]') || form.contains(event.target)) {
      if (form.reportValidity()) navigate(formURL(form).href);
    }
  });
  window.addEventListener('resize', offset);
  window.addEventListener('popstate', event => {
    if (!root) return;
    navigate(location.href, { pop: true, restore: event.state?.sc3Listing || { urls: [location.href], y: 0 } });
  });
  window.addEventListener('scroll', () => {
    clearTimeout(scrollFrame);
    if (!root || root.hasAttribute('aria-busy')) return;
    scrollFrame = setTimeout(() => { scrollFrame = 0; save(); }, 250);
  }, { passive: true });
  // Leaving the page (to search, a product, another page) must not freeze the filter sheet open in the
  // back/forward cache: close it on the way out and again if a cached page is shown.
  window.addEventListener('pagehide', () => { closeSheet(false); save(); });
  window.addEventListener('pageshow', event => { if (event.persisted) closeSheet(false); });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || !root || link.target === '_blank' || event.defaultPrevented) return;
    if (!$('[data-sc3-filter-dialog]', root)?.contains(link) && link.closest('[data-sc3-listing]') !== root) closeSheet(false);
  }, true);
  document.addEventListener('shopify:section:load', event => {
    const next = $('[data-sc3-listing]', event.target);
    if (next) { controller?.abort(); sequence++; closeSheet(false); init(next); urls = [location.href]; }
  });
  document.addEventListener('shopify:section:unload', event => {
    if (!root || !event.target.contains(root)) return;
    clearTimeout(scrollFrame);
    controller?.abort(); sequence++; closeSheet(false); observer?.disconnect(); resize?.disconnect(); root = null;
  });
  const start = () => {
    const node = $('[data-sc3-listing]');
    if (!node) return;
    init(node);
    const saved = history.state?.sc3Listing;
    urls = [cleanURL(location.href).href];
    if (saved?.urls?.length > 1) navigate(location.href, { pop: true, restore: saved });
    else if (root.dataset.sc3SearchPage === 'true' && new URL(location.href).searchParams.get('type') !== 'product') navigate(location.href, { replace: true });
    else save();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
